<script setup lang="ts">
import Wrapper                              from "../../Layouts/Wrapper.vue";
import Container                            from "../../CommonComponents/Container.vue";
import Section                              from "../../CommonComponents/Section.vue";
import SectionTitle                         from "../../CommonComponents/SectionTitle.vue";
import __                                   from "../../../Utils/tranlation";
import { useForm, usePage }                 from "@inertiajs/vue3";
import { onMounted, useTemplateRef }        from "vue";
import { handleValidateForms, removeClass } from "../../../Utils/helpers";
import AlertDanger                          from "../../CommonComponents/AlertDanger.vue";
import AlertSuccess                         from "../../CommonComponents/AlertSuccess.vue";

type TypeProps = {
    success? : string,
    title? : string,
    id : string,
    name : string,
};

const props = defineProps<TypeProps>();

const form = useForm({
    _token: usePage().props.csrf_token,
    error_qr_code: null,
    name: (props.name.length ? props.name : null),
});

const formEl = useTemplateRef('formEl');

const reactiveForm = (e : Event) : void => {
    if ((e.target as HTMLFormElement).checkValidity()) {
        form.patch(
            route('simple-qr-code.update', {id: props.id}), {
                onSuccess: () => {
                    form.clearErrors();
                    removeClass('was-validated', formEl.value);
                    // @ts-ignore
                    form.reset(['name']);
                }
            }
        );
    }
};

onMounted(() => {
    handleValidateForms();
});
</script>

<template>
    <Wrapper :title>
        <template #main>
            <Section>
                <Container>
                    <SectionTitle class="mb-6">
                        {{ __('text_title') }}
                    </SectionTitle>

                    <template v-for="error in form.errors">
                        <AlertDanger :error></AlertDanger>
                    </template>

                    <AlertSuccess :success></AlertSuccess>

                    <form @submit.prevent="reactiveForm($event)"
                          ref="formEl"
                          class="flex flex-col gap-y-6 max-w-sm mx-auto needs-validation"
                          novalidate>

                        <div>
                            <label for="name"
                                   class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {{ __('text_name') }}
                            </label>

                            <input type="text" id="name" v-model="form.name"
                                   class="bg-gray-50 border border-gray-300 text-gray-900
                                           text-sm rounded-lg focus:ring-blue-500
                                           focus:border-blue-500 block w-full p-2.5
                                           dark:bg-gray-700 dark:border-gray-600
                                           dark:placeholder-gray-400 dark:text-white
                                           dark:focus:ring-blue-500 dark:focus:border-blue-500"/>
                        </div>

                        <button type="submit"
                                :disabled="form.processing"
                                class="text-white bg-blue-700
                                       hover:bg-blue-800 focus:ring-4 focus:outline-none
                                       focus:ring-blue-300 font-medium rounded-lg
                                       text-lg w-full sm:w-auto px-5 py-2.5 text-center
                                       dark:bg-blue-600 dark:hover:bg-blue-700
                                       dark:focus:ring-blue-800">
                            {{ __('text_submit') }}
                        </button>
                    </form>
                </Container>
            </Section>
        </template>
    </Wrapper>
</template>

<style scoped>

</style>
